<script>
    // Licensed under Gnu Public Licence version 2
    // Copyright (c) 2021-2022 (original work) Open Assessment Technologies SA
    import {
        NotificationContainer,
        setNotificationContainerOptions,
        removeNotification
    } from '@oat-sa-private/ui-components';

    setNotificationContainerOptions({ sortByAutoclose: true });

    /**
     * On notification generated due to failed ACS request, redirects to retry acs view.
     * The route is generated transforming 'actionName' into 'retryActionName'
     * @param {Object} event - click event
     * @param {Object} event.detail - click event details
     * @param {String} event.detail.key - Notification key
     * @param {Object} event.detail.data - Notification data
     * @param {Function} event.detail.data.closeCallback
     */
    function handleClose({ detail: closedNotification }) {
        removeNotification(closedNotification.key);

        if (closedNotification.data && typeof closedNotification.data.closeCallback === 'function') {
            closedNotification.data.closeCallback();
        }
    }
</script>

<NotificationContainer on:notificationclose={handleClose} />
